export type ProductImpression = {
  currencyCode: string;
  add?: string;
  remove?: string;
  impressions: Array<ProductImpressionItem>;
};

export type ProductImpressionItem = {
  id: number;
  name: string;
  price: string;
  brand: string;
  category: string;
  variant: string;
  list: string;
};
